<template>
  <contact-filter-field
    :schema="filterSchema"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
import ContactFilterField from '@/components/formFields/ContactFilterField';

export default {
  name: 'ReportContactFilter',
  components: { ContactFilterField },
  props: {
    schema: { type: Object, default: () => ({}) },
    value: { default: null },
  },
  computed: {
    filterSchema() {
      return {
        label: this.schema.title || 'Contact Filters',
        showCount: false,
        ...this.schema,
      };
    },
  },
};
</script>
